import Vue from 'vue';
import store from './store.js';
import {
    LiveSearch,
    CollectionComponent,
    PaginatedCollectionComponent,
    SyncsWithUrl,
    ResetsPage,
} from 'clockvine-vue';

const app = new Vue({
    el: 'main',
    store,

    data: {
        params: {
            page: 1,
            search: '',
            type: null,
        },
    },

    methods: {
        getPageRange(currentPage, totalPages) {
            if (currentPage < 3) {
                return [1, 2, 3, 4, 5].filter(n => n <= totalPages);
            } else if (currentPage > totalPages - 2) {
                return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages].filter(n => n > 0);
            }
            return [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2].filter(n => n > 0 && n <= totalPages);
        },

        nextPageUrl() {
            return this.pageUrl(this.params.page + 1);
        },

        prevPageUrl() {
            return this.pageUrl(this.params.page - 1);
        },

        pageUrl(page) {
            // Takes the current url, and updates the page param to the given value
            const url = new URL(window.location.href);
            url.searchParams.set('page', page);
            return url.toString();
        },

        filterSolution(event) {
            // takes the current url, and updates the type param to the given value
            const url = new URL(window.location.href);
            console.log(event);
            if (event.target.value === 'null') {
                url.searchParams.delete('solution');
            } else {
                url.searchParams.set('solution', event.target.value);
            }
            url.searchParams.set('page', 1);
            window.location.href = url.toString();
        },

        filterProduct(event) {
            // takes the current url, and updates the type param to the given value
            const url = new URL(window.location.href);
            console.log(event);
            if (event.target.value === 'null') {
                url.searchParams.delete('product');
            } else {
                url.searchParams.set('product', event.target.value);
            }
            url.searchParams.set('page', 1);
            window.location.href = url.toString();
        }

    },

    mixins: [
        new SyncsWithUrl('params', {
            page: 1,
            orderBy: 'blogPostDate desc',
        }),
        new ResetsPage(),
    ],

    components: {
        blogPosts: PaginatedCollectionComponent.for('blogPosts'),
        blogSolutions: CollectionComponent.for('blogSolutions'),
        blogProducts: CollectionComponent.for('blogProducts'),
        search: LiveSearch,
    },
});
